<template>
  <div :class="styleClass">
    <div
      class="period_header"
      :class="{
        period_header_7: type == 7,
        disabledStyle: !$services.CourseService.checkLiveState(type, period),
      }"
      @click="targetPeriod(period)"
    >
      <div
        class="period_title"
        :class="{
          activePeriod: period.id == period_id,
          period_title_10: type == 10,
        }"
        :title="period.periods_title"
      >
        <CoursePeriodsType
          :styleClass="styleClass + 'type'"
          class="f-left"
          :periods_type="period.periods_type"
        ></CoursePeriodsType>
        <span class="period_title_content eps">{{ period.periods_title }}</span>
        <span class="ks_catalog_title_haslearnpercent">
          已学习{{ period.progress_rate }}%
        </span>

        <span
          class="period_state"
          :class="'period_state' + period.play_type.toString()"
          v-if="type != 5 && type != 10"
        >
          <template v-if="type == 2 || type == 15 || type == 3">
            <template v-if="period.play_type == 1">
              <img src="@/assets/images/video/play_type1.png" />
              <font>未开始</font>
            </template>
            <template v-else-if="period.play_type == 2">
              <img src="@/assets/images/video/play_type2.png" />
              <font>直播中</font>
            </template>
            <template
              v-else-if="
                period.play_type == 3 ||
                period.play_type == 4 ||
                period.play_type == 5
              "
            >
              <img
                src="@/assets/images/video/play_type3.png"
                style="opacity: 0.5"
                v-if="!$services.CourseService.checkLiveState(type, period)"
              />
              <img src="@/assets/images/video/play_type44.png" v-else />
              <font
                v-if="!$services.CourseService.checkLiveState(type, period)"
              >
                已结束
              </font>
              <font v-else>回放</font>
            </template>
            <template v-else>
              <img src="@/assets/images/video/play_type3.png" />
              <font>已结束</font>
            </template>
          </template>
          <template v-else-if="type == 7">
            <template v-if="period.play_type == 1">未开始</template>
            <template v-else-if="period.play_type == 2">上课中</template>
            <template v-else-if="period.play_type == 3">已结束</template>
          </template>
        </span>
        <span v-else class="ks_catalog_title_date">
          {{ $pub.timeMeter(period.total_time) }}
        </span>
      </div>
    </div>
    <CourseContentTip
      v-if="showContentDialog"
      :show.sync="showContentDialog"
      :content="chapter_content"
    ></CourseContentTip>
    <CourseSoldOutTip :show.sync="showSoldOut"></CourseSoldOutTip>
  </div>
</template>
<script>
import CoursePeriodsType from "@/modules/stu/components/CoursePeriodsType";

import CourseSoldOutTip from "@/modules/stu/components/CourseSoldOutTip.vue";
import CourseContentTip from "@/modules/stu/components/CourseContentTip";
export default {
  name: "VideoCoursePeriod",
  components: { CourseSoldOutTip, CoursePeriodsType, CourseContentTip },
  props: {
    period: {
      type: Object,
    },
    course: {
      type: Object,
    },
    tryText: {
      type: String,
      default: "试看",
    },
    styleClass: {
      type: String,
      default: "",
    },
    isVideo: {
      type: Boolean,
    },
    onPeriodTap: {
      type: Function,
    },
  },
  data() {
    return {
      parent: this.$route.query.parent,
      period_id: this.$route.query.period_id,
      showContentDialog: false,
      chapter_content: "",
      showSoldOut: false,
    };
  },
  watch: {
    $route: {
      handler: function () {
        this.period_id = this.$route.query.period_id;
      },
      // 深度观察监听
      deep: true,
    },
  },
  computed: {
    commonSetting() {
      return this.$store.state.commonSetting;
    },
    type() {
      return this.period.periods_type;
    },
    // video页混合课
    videoMixCoures() {
      if (this.isVideo) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {},
  methods: {
    async visitFile(id, index) {
      if (this.course.is_buy == 0) {
        return this.$info("请您先报名");
      }
      await this.$services.CourseService.openPeriodFile(
        this.period,
        id,
        index,
        this.parent,
      );
    },
    async targetPeriod(period, type) {
      if (!this.$services.CourseService.checkLiveState(this.type, period)) {
        return false;
      }
      if (this.course.is_buy == 0 && period.is_try_see == 0) {
        return this.$info("请您先报名");
      }
      if (this.course.is_buy == 1) {
        await this.$services.CourseService.checkLimit(this.course.id);
        if (!this.$services.CourseService.checkBuyValid(this.course)) {
          return this.$info("该课程已过期，无法继续学习");
        }
      }
      if (this.videoMixCoures && this.type == 5) {
        this.onPeriodTap();
      }
      if (this.type == 7 && this.period.content) {
        this.chapter_content = this.period.content;
        this.showContentDialog = true;
        return;
      }
      if (this.type == 10) {
        let data = await this.$services.CourseService.getPeriodContent(
          period,
          this.parent,
        );
        this.chapter_content = data.course_content;
        this.showContentDialog = true;
      } else {
        if (!type) {
          type = 1;
        }
        await this.$services.CourseService.watchVideo(
          period,
          this.type,
          this.course.id,
          type,
        );
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.chapter_content_child {
  width: 100%;
  float: left;
  .period_header {
    padding: 0px 20px 0px 34px !important;
  }
}
.chapter_content_parent {
  width: 100%;
  float: left;
}
.period_header {
  height: 30px;
  line-height: 30px;
  padding: 0px 20px 0px 30px;
  width: 100%;
  float: left;
  cursor: pointer;
  box-sizing: border-box;
  .period_title {
    width: 100%;
    float: left;
    position: relative;
    .period_title_content {
      width: 170px;
      float: left;
    }
    .ks_catalog_title_date {
      margin-left: 10px;
      font-size: 12px;
      float: right;
    }
    .period_state {
      float: right;
      img {
        height: 20px;
        float: left;
        margin-top: 5px;
      }
      font {
        line-height: 30px;
        float: left;
        padding-left: 5px;
      }
    }
    .ks_catalog_title_haslearnpercent {
      margin-left: 10px;
      font-size: 12px;
      float: right;
    }
  }
}
.disabledStyle {
  cursor: not-allowed !important;
  color: rgba(255, 255, 255, 0.3);
}
</style>
